import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-551">
      <Navbar data-id="element-552" />
      <main className="pt-32 pb-24" data-id="element-553">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-555">
            Privacy Policy
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-556">
            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-557">
              General
            </h2>
            <p data-id="element-558">
              Your privacy is important to us. It is KittyPot Ltd.'s policy to
              respect your privacy regarding any information we may collect from
              you across our website, https://www.kittypot.com, and any other
              sites or services we own and operate.
            </p>

            <p data-id="element-559">
              We only collect personal information where it is genuinely
              necessary to provide our services. We collect information by fair
              and lawful means, with your knowledge and consent, and we clearly
              explain why it is being collected and how it will be used.
            </p>

            <p data-id="element-560">
              We retain personal information only for as long as necessary to
              deliver the service you have requested. Any data we store is
              protected using commercially reasonable measures to prevent loss,
              theft, unauthorised access, disclosure, copying, use, or
              modification.
            </p>

            <p data-id="element-561">
              We do not share personally identifiable information publicly or
              with third parties, except where required to do so by law or where
              necessary to provide our services.
            </p>

            <p data-id="element-562">
              You may request the deletion of your personal data at any time,
              and we will securely erase it in accordance with applicable data
              protection laws.
            </p>

            <p data-id="element-563">
              Our website may contain links to external websites that are not
              operated by us. Please note that we have no control over the
              content or practices of these sites and cannot accept
              responsibility or liability for their respective privacy policies.
            </p>

            <p data-id="element-564">
              You are free to decline our request for personal information,
              however this may mean we are unable to provide certain services.
            </p>

            <p data-id="element-565">
              Your continued use of our website will be regarded as acceptance
              of our privacy practices. If you have any questions about how we
              handle user data and personal information, please contact us at
              support@kittypot.com.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-566">
              Sign-Up & Contact
            </h2>
            <p data-id="element-567">
              You can join our waitlist or contact us via the contact form on
              our website. If you have any questions or require assistance,
              we're always happy to help.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-568">
              Cookie Policy
            </h2>
            <p data-id="element-569">
              Cookies are small text files placed on your device by a website's
              server. They help websites function properly, remember user
              preferences, and improve the overall user experience.
            </p>

            <p data-id="element-570">We use cookies for the following purposes:</p>
            <ul className="list-none space-y-4" data-id="element-571">
              <li data-id="element-572">
                <strong data-id="element-573">a) Identification</strong> — Cookies help us recognise
                your device so you don't need to re-enter information repeatedly
                when navigating between pages.
              </li>
              <li data-id="element-574">
                <strong data-id="element-575">b) Analytics</strong> — Cookies help us understand how
                visitors use our website, such as which pages are viewed and how
                often, so we can improve performance and usability.
              </li>
            </ul>

            <p data-id="element-576">
              You can choose to disable cookies through your browser settings.
              Please note that disabling cookies may limit certain functionality
              of the website.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-577" />
    </div>;
}